<template>
  <div class="diy-attribute">
    <el-input v-if="type === 'input'" v-model="curValue" @input="update"></el-input>
    <el-select filterable v-if="type=='select'" v-model="curValue" @change="update">
      <el-option v-for="(item,index) in curOption" :key="index" :label="item" :value="item"></el-option>
    </el-select>
    <el-radio-group v-if="type === 'radio'" v-model="curValue" @change="update">
      <el-radio v-for="(item,index) in curOption" :key="index" :label="item">
        {{item}}
      </el-radio>
    </el-radio-group>
    <el-select filterable v-if="type === 'multipleSelect'" @change="update" v-model="curValue" multiple placeholder="请选择">
      <el-option
        v-for="item in curOption"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
    <el-input
      v-if="type === 'number'"
      class="diy-input-number"
      @blur="update"
      type="number"
      v-model="curValue"
      placeholder="请输入数字">
    </el-input>
    <el-select
      filterable
      remote
      @focus="getMyOptions(attr)"
      v-if="type === 'model'"
      :multiple-limit="10"
      @change="update"
      v-model="curValue"
      multiple
      :remote-method="remoteMethod"
      :loading="loading">
      <el-option
        v-for="item in curOption === undefined ? [] : curOption"
        :key="'model' + item.id"
        :label="item.value"
        :value="item.id">
      </el-option>
    </el-select>
    <el-checkbox-group  v-if="type=='checkBox'" v-model="curValue" @change="update">
      <el-checkbox v-for="(item,index) in curOption" :key="index" :label="item">{{ item }}</el-checkbox>
    </el-checkbox-group>
    <el-date-picker
      @change="update"
      v-if="type === 'datePicker'"
      v-model="curValue"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
    <el-date-picker
      @change="update"
      v-if="type=='dateTimePicker'"
      v-model="curValue"
      type="datetime"
      value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期">
    </el-date-picker>
    <el-cascader
      @change="update"
      v-if="type=='addressPicker'"
      :options="regionData"
      v-model="curValue">
    </el-cascader>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getMyAboutModelList } from '@/api/set.js'
export default {
  name: 'field',
  props: ['type', 'option', 'value', 'attr'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      attrQuery: '',
      attrValue: '',
      loading: false,
      regionData: regionDataPlus,
      curValue: this.value,
      curOption: this.option
    }
  },
  watch: {
    value: function (val) {
      this.curValue = val
    }
  },
  /*
  computed: {
    val: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.curValue = newValue
      }
    }
  },
  */
  methods: {
    // 远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.attrQuery = query
        this.loading = true
        let modelId = JSON.parse(this.attrValue.options)[0].modelId
        let identity = JSON.parse(this.attrValue.options)[2].identity
        getMyAboutModelList(modelId, identity, query).then((res) => {
          if (res.data.code == 200) {
            this.loading = false
            this.curOption = res.data.result.list
          }
        })
      } else {
        this.curOption = []
      }
    },
    // 模型加载自己的对应的选项
    getMyOptions(attr) {
      this.attrValue = attr
      let modelId = JSON.parse(attr.options)[0].modelId
      let identity = JSON.parse(attr.options)[2].identity
      // if (query !== '') {
      //   this.loading = true
      //   let modelId = JSON.parse(this.attrValue.options)[0].modelId
      //   let identity = JSON.parse(this.attrValue.options)[2].identity
      //   getMyAboutModelList(modelId, identity, this.attrQuery).then((res) => {
      //     if (res.data.code == 200) {
      //       this.loading = false
      //       this.curOption = res.data.result.list
      //     }
      //   })
      // } else {
      //   this.curOption = []
      // }
    },
    update() {
      let value = []
      console.log('curValue', this.curValue)
      if (this.type === 'address') {
        value[0] = CodeToText[val[0]]
        value[1] = CodeToText[val[1]]
        value[2] = CodeToText[val[2]]
      } else {
        value = this.curValue
      }
      this.$emit('change', value)
    }
  },
  created() {
    console.log('option', this.option)
  }
}
</script>

<style scoped>
.diy-attribute{text-align: left}
</style>
